const ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789';

/**
 * Short, collision-resistant, human-typeable ids.
 *
 * Ids appear in agent transcripts and CLI arguments constantly, so readability
 * beats absolute entropy here: `blur_k3f9a2` is far easier for an agent to
 * quote back correctly than a UUID, and the graph-scoped uniqueness check in
 * `Graph.addNode` closes the remaining gap.
 */
export function shortId(prefix: string): string {
  let s = '';
  for (let i = 0; i < 6; i++) s += ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
  return `${sanitize(prefix)}_${s}`;
}

function sanitize(prefix: string): string {
  const cleaned = prefix.toLowerCase().replace(/[^a-z0-9]+/g, '');
  return cleaned.slice(0, 12) || 'n';
}

/**
 * Deterministic 32-bit string hash (FNV-1a).
 *
 * Used to key the evaluation cache. Not cryptographic — a collision costs a
 * stale thumbnail, not correctness of a saved document.
 */
export function hashString(input: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}
